var React = require('react');
var ReactDOM = require('react-dom');

var IncidentTemplateListItem = require('./incident_template_list_item');
var EditFieldModal = require('./../../edit_field_modal');

const ClosedState = "fa fa-plus-square-o";
const OpenState = "fa fa-minus-square-o";

class IncidentTemplateListGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = { groupShow: OpenState };
  }

  _toggleDropdown() {
    if (this.state.groupShow == ClosedState) {
      this.setState({groupShow: OpenState});
    } else {
      this.setState({groupShow: ClosedState});
    }
  }

  _showTemplateGroups() {
    var pageParam = this.props.pageParam;

    return (
      <div>
        { this.props.group.templates.map(function (template) {
          return (
            <div className="template-sub-item" key={template.id}>
              <IncidentTemplateListItem template={template} pageParam={pageParam} />
            </div>
          );
        })}
      </div>
    );
  }

  _triggerEditModal(event) {
    event.preventDefault();
    event.stopPropagation();
    $(ReactDOM.findDOMNode(this)).find('#modal-confirmation-edit-incident-template-group-name').modal();
  }

  _handleDelete() {
    if (window.confirm("Are you sure you want to delete this template group? Templates in this group won't be deleted, but will become \"ungrouped\" templates.")) {
      $.ajax({
        type: 'DELETE',
        url: Routes.page_incident_template_group_path(this.props.pageParam, this.props.group.param),
        dataType: 'JSON',
        success: function (data, textStatus, xhr) {
          window.location.reload(true);
        },
        error: function(xhr, textStatus) {
          HRB.utils.basicFailAndReload(xhr);
        }
      });
    }
  }

  render() {
    var group = this.props.group;

    return(
      <div className="table-row">
        <i className={this.state.groupShow} onClick={this._toggleDropdown.bind(this)}></i>
        <div className="template-meta">
          <strong>{ group.name }</strong>
        </div>
        <a href='#' onClick={this._triggerEditModal.bind(this)}>Edit</a>
        <a href='#' className="template-delete" onClick={this._handleDelete.bind(this)}>Delete</a>

        { this.state.groupShow == OpenState ? this._showTemplateGroups() : null }

        <EditFieldModal id="edit-incident-template-group-name"
                        title={"Edit " + group.name}
                        putUrl={Routes.page_update_group_name_path(this.props.pageParam)}
                        owningEntityParam={group.param}
                        label="Group Name"
                        placeholder={group.name}
                        paramName="group_name"
                        submit_text="Save"/>
      </div>
    );
  }
}

module.exports = IncidentTemplateListGroup;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/incident_templates/incident_template_list_group.jsx